<template>
  <div
      class="chat-container"
      @dragover.prevent="handleDragOver"
      @dragleave.prevent="handleDragLeave"
      @drop.prevent="handleDrop"
  >
    <!-- 拖拽上传遮罩层 -->
    <transition name="drag-fade">
      <div
          v-show="isDragOver&&!showAgentUI"
          class="drag-overlay"
      >
        <div class="drag-content">
          <i class="el-icon-upload" style="font-size: 64px; color: #409EFF"></i>
          <p class="drag-text">文件拖动到此处即可上传</p>
          <p>最多支持6个文件，每个文件不超过2M，上传文件总和不超过8M，仅提取文字，接受pdf、doc、xlsx、ppt、图片、文本、代码等</p>
        </div>
      </div>
    </transition>
    <template v-if="showAgentUI">
      <div class="agent-box">
        <img alt="" class="agent-title" src="@/assets/images/home2.png">
        <div class="agent-list">
          <div v-for="item in agent_list" :key="item.id" :class="[!item.enable?'agent-active':'']"
               class="agent-item" @click="agentSelect(item)">
            <div>{{ item.name }}</div>
            <div>{{ item.desc }}</div>
          </div>
        </div>
        <SvgIcon
            :size="32"
            iconClass="agent-back"
            name="agent_back"
            @click.native="agent_back"
        />
      </div>
    </template>
    <template v-else>
      <div class="navBar">
        <span v-if="agent_list&&agent_list.length>0">{{ robot.name }}</span>
        <SvgIcon
            v-if="model_role_enable"
            :size="24"
            iconClass="haoyou-btn"
            name="haoyou"
            @click.native="robotRolesClick"
        />
        <SvgIcon
            :size="24"
            iconClass="huaban-btn"
            name="huaban"
            @click.native="$emit('agentOpen')"
        />
      </div>
      <!--      <ChatHeader-->
      <!--          :title="title"-->
      <!--          @edit-title="$emit('edit-title')"-->
      <!--      />-->
      <div v-if="displayConversations.length > 0" :class="displayConversations.length>1?gridColClass:''"
           class="out-box-content">
        <!-- 按模型分组渲染 -->
        <div
            v-for="(conv, mdx) in displayConversations"
            :key="conv.model_info.id || mdx"
            class="conversation-col"
        >
          <ChatContent
              ref="chatContent"
              :chat_id="chat_id"
              :client_id="client_id"
              :column-sender-open="columnArrowDown[mdx]"
              :dify-config="difyConfig"
              :is-loading-messages="isLoadingMessages || !!conv.sending"
              :is-loading-suggestions="isLoadingSuggestions"
              :map-file-type="mapFileType"
              :messages="conv.messages"
              :model-info="conv.model_info"
              :multi-model="displayConversations.length > 0"
              :pager="conv.pager"
              :robot="robot"
              :show-suggested-questions="showSuggestedQuestions"
              :suggested-questions="suggestedQuestions"
              :summary_status="summary_status"
              @onLoadMore="$emit('onLoadMore', mdx)"
              @column-send="$emit('column-send', $event)"
              @edit-message="$emit('edit-message', $event)"
              @retry-message="$emit('retry-message', $event)"
              @update-feedback="$emit('update-feedback', $event)"
              @share-click="$emit('share-click', $event)"
              @prompt-click="$emit('prompt-click', $event)"
              @suggested-question-click="$emit('suggested-question-click', $event)"
              @update-workflow-active="$emit('update-workflow-active', $event)"
              @update-node-active="$emit('update-node-active', $event)"
              @summary-click="$emit('summary-click', $event)"
          />
          <!-- 多模型分组(>1)时，在会话框底部边线中间显示操作按钮，hover 整个对话框才出现 -->
          <button
              v-if="displayConversations.length > 1&&chat_id>0"
              class="column-action-btn"
              @click.stop="toggleColumnAction(mdx)"
          >
            <i :class="columnArrowDown[mdx] ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
          </button>
        </div>
      </div>
      <!-- 无模型选择时的占位提示 -->
      <div v-else class="empty-conversations">
        <div class="empty-tip">请选择对比模型</div>
      </div>
      <ChatInput
          :chat_id="chat_id"
          :is-select="isSelect"
          :loading="loading"
          :models="models"
          :uploaded-files="uploadedFiles"
          :value="senderValue"
          @input="$emit('update:sender-value', $event)"
          @modelSelectEvent="modelSelectEvent"
          @send="$emit('send', $event)"
          @stop="$emit('stop')"
          @file-upload="$emit('file-upload')"
          @delete-file="$emit('delete-file', $event)"
          @update:is-select="$emit('update:is-select', $event)"
      />
    </template>
    <RoleSettings
        v-if="roleSettingsVisible"
        :robot_id="robot_id"
        :roleSettingsVisible.sync="roleSettingsVisible"
    />
  </div>
</template>

<script>
import ChatContent from './ChatContent.vue';
import ChatHeader from './ChatHeader.vue';
import ChatInput from './ChatInput.vue';
import RoleSettings from "@/components/RoleSettings.vue";

export default {
  name: 'ChatContainer',
  components: {
    RoleSettings,
    ChatHeader,
    ChatContent,
    ChatInput,
  },
  props: {
    robot: {
      type: Object,
      default: () => ({}),
    },
    client_id: {},
    summary_status: {
      type: Boolean,
      default: false
    },
    chat_id: {
      type: Number,
      default: 0
    },
    model_role_enable: { //角色配置显隐
      type: Boolean,
      default: false
    },
    models: {
      type: Array,
      default: () => []
    },
    robot_id: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: '',
    },
    isLoadingMessages: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isSelect: {
      type: Boolean,
      default: false,
    },
    uploadedFiles: {
      type: Array,
      default: () => [],
    },
    mapFileType: {
      type: Function,
      required: true,
    },
    difyConfig: {
      type: Object,
      required: true,
    },
    senderValue: {
      type: String,
      default: '',
    },
    suggestedQuestions: {
      type: Array,
      default: () => [],
    },
    showSuggestedQuestions: {
      type: Boolean,
      default: false,
    },
    isLoadingSuggestions: {
      type: Boolean,
      default: false,
    },
    agent_list: {
      type: Array,
      default: () => [],
    },
    showAgentUI: {
      type: Boolean,
      default: false,
    },
    modelConversations: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      roleSettingsVisible: false,
      // 拖拽上传状态
      isDragOver: false,
      // 各模型列按钮箭头方向：true=下箭头（默认上箭头）
      columnArrowDown: {},
    };
  },
  computed: {
    // 移动端不分栏，只展示第一个模型
    displayConversations() {
      const list = this.modelConversations
      if (list.length <= 1) return list
      const isMobile = window.innerWidth < 768
      return isMobile ? [list[0]] : list
    },
    // 根据模型数量计算grid列数
    gridColClass() {
      const n = this.displayConversations.length
      if (n === 2 || n === 4) return 'cols-2'
      if (n >= 3) return 'cols-3'
      return ''
    }
  },
  watch: {
    // 切换会话/新建会话后，列内发送框默认收起
    chat_id() {
      this.columnArrowDown = {}
    },
    // 模型分组数量变化（如重新勾选模型、历史加载出新模型）时重置，避免状态落到错误的列
    'modelConversations.length'() {
      this.columnArrowDown = {}
    },
    // 非多模型（移动端/单模型）时强制隐藏——此时选项卡按钮不渲染，无法手动收起
    displayConversations(list) {
      if (list.length <= 1) {
        this.columnArrowDown = {}
      }
    }
  },
  methods: {
    modelSelectEvent(e) {
      this.$emit('modelSelectEvent', e);
    },
    agentSelect(e) {
      if (!e.enable) return
      //回传选择的智能体给父组件
      this.$emit('agentBack', e.id)
    },
    robotRolesClick() {
      this.roleSettingsVisible = true
    },
    // 切换某列按钮箭头方向（上/下），展开/收起列内发送框
    toggleColumnAction(mdx) {
      this.$set(this.columnArrowDown, mdx, !this.columnArrowDown[mdx])
    },
    agent_back() {
      this.$emit('agentBack');
    },

    // 拖拽上传处理方法
    handleDragOver(e) {
      e.preventDefault();
      // 当 showAgentUI 为 true 时，不显示遮罩层
      if (this.showAgentUI) {
        return;
      }
      e.dataTransfer.dropEffect = 'copy';
      this.isDragOver = true;
    },

    handleDragLeave(e) {
      e.preventDefault();
      this.isDragOver = false;
    },

    handleDrop(e) {
      e.preventDefault();
      // 当 showAgentUI 为 true 时，不处理拖拽上传
      if (this.showAgentUI) {
        return;
      }
      this.isDragOver = false;

      const files = e.dataTransfer.files;
      if (files && files.length > 0) {
        // 通过事件通知父组件处理文件上传（使用 file-drop 事件名区分点击上传）
        this.$emit('file-drop', files);
      }
    },
  },
};
</script>


<style lang="scss" scoped>
$--color-white: #ffffff;

.chat-container {
  max-width: none !important;
  background-color: $--color-white !important;
  transition: margin-left 0.3s ease;
  position: relative;

  .agent-back {
    cursor: pointer;
  }

  .haoyou-btn {
    margin-left: 16px;
    cursor: pointer;
  }

  .huaban-btn {
    cursor: pointer;
    margin-left: 16px;
  }

  .conversation-col {
    position: relative;
    height: 100%;
    min-height: 0;
  }

  // 会话框底部边线中间的按钮（仅多模型分组时渲染，hover 整个对话框才出现）
  // 样式：白色底 + 与边框同色描边，像"选项卡"一样贴在底部边线上
  .column-action-btn {
    position: absolute;
    left: 50%;
    bottom: 0; // 底边贴齐会话框底部边线
    transform: translateX(-50%);
    z-index: 10;
    height: 16px;
    padding: 0 1.25rem;
    border: 1px solid #8CC5FF;
    border-bottom: none; // 与会话框边线融合
    border-radius: 8px 8px 0 0; // 只圆上边两个角
    color: #4D79FF; // 与页面主色一致，白底上清晰可见
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px; // 箭头图标大小
    line-height: 1;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease, background-color 0.2s ease;

    &:hover {
      background: #f0f6ff; // 浅蓝，与页面气泡色系一致
    }
  }

  // 整个会话框 hover 时显示按钮
  .conversation-col:hover .column-action-btn {
    opacity: 1;
    pointer-events: auto;
  }

  .out-box-content {
    flex: 1;
    height: 100%;
    overflow: auto;

    .chat-content {
      position: relative;
      min-height: 100%;
      padding: 0 32px 15px 32px;
    }

    ::v-deep .el-x-bubble-content {
      font-size: 16px !important;
    }

    // 只有一个 ChatContent 时，气泡列表最大宽度 960px（居中单栏布局）
    .chat-content:only-child {
      ::v-deep .el-x-bubble-list {
        padding: 12px;
        //max-width: 960px;
      }

    }

    // 多个 ChatContent 时，气泡列表宽度 100%（平分屏幕）
    ::v-deep .el-x-bubble-list {
      height: auto;
      max-height: none;
      width: 100%;
      max-width: 100%;
      margin: 0 auto;

      .markdown-body {
        font-size: 16px !important;
        contain: layout inline-size !important;
        max-width: 100%;

        h1 {
          font-size: 1.4em;
        }

        h2 {
          font-size: 1.2em;
        }

        h3 {
          font-size: 1.1em;
        }

        h4 {
          font-size: 1.05em;
        }
      }

      .el-x-bubble {
        gap: unset !important;
      }
    }

    // 多模型分栏：根据数量固定列数（参考grid2.html方案）
    &.cols-2 {
      display: grid;
      gap: 16px;
      grid-template-columns: repeat(2, 1fr);
      overflow: hidden;
      margin: 16px;

      .conversation-col {
        border-radius: 0.75rem;
        border: 1px solid #8CC5FF;
        overflow: hidden;
      }

      .chat-content {
        height: 100%;
        overflow-y: overlay;
        overflow-x: hidden;
        min-height: auto;
        padding: 0;
        box-sizing: border-box;

        ::v-deep .el-x-bubble-list {
          padding: 12px;
        }
      }
    }

    // 3列及以上
    &.cols-3 {
      display: grid;
      gap: 16px;
      grid-template-columns: repeat(3, 1fr);
      overflow: hidden;
      margin: 16px;

      .conversation-col {
        border-radius: 0.75rem;
        border: 1px solid #8CC5FF;
        overflow: hidden;
      }

      .chat-content {
        height: 100%;
        overflow-y: overlay;
        overflow-x: hidden;
        min-height: auto;
        padding: 0;
        box-sizing: border-box;

        ::v-deep .el-x-bubble-list {
          padding: 12px;
        }
      }
    }
  }

  .chat-input {
    margin: 0 16px;
  }

  .navBar {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 20px;
    line-height: 64px;
    color: #333333;

    img {
      width: 32px;
      height: 32px;
      display: flex;
      cursor: pointer;
    }
  }

  .agent-box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    overflow-y: auto;

    .agent-title {
      width: 315px;
      height: 52px;
      margin-bottom: 20px;
      display: flex;
    }

    .agent-list {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(186px, 1fr));
      row-gap: 16px;
      column-gap: 32px;
      padding: 48px 20px;

      .agent-item {
        background: #E5EBFF;
        border-radius: 16px;
        border: 1px solid #4D79FF;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 24px 10px;
        cursor: pointer;

        div:first-child {
          font-weight: 500;
          font-size: 18px;
          color: #333333;
          line-height: 28px;
          margin-bottom: 8px;
        }

        div:last-child {
          color: #666666;
          line-height: 24px;
          height: 48px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }

      .agent-active {
        border-radius: 16px 16px 16px 16px;
        border: 1px solid #DCDCDC;
        background: #ffffff;

        div:first-child {
          color: #999999;
        }

        div:last-child {
          color: #999999;
        }
      }

    }
  }

  @media (max-width: 767px) {
    margin-top: 60px;
    max-width: none;
    .agent-list {
      grid-template-columns: repeat(auto-fit, minmax(80px, 1fr)) !important;
      row-gap: 6px !important;
      column-gap: 6px !important;
    }
    .agent-item {
      padding: 6px !important;

      div {
        font-size: 12px !important;
        line-height: 1;
      }

      div:last-child {
        height: auto !important;
        min-height: 0 !important;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
    }
    .chat-input {
      margin: 0 !important;
    }
    .chat-content {
      padding: 0 16px 15px 16px !important;
    }

    // 移动端多模型分栏适配
    .cols-2,
    .cols-3 {
      margin: 0 12px;
      gap: 8px;

      .chat-content {
        padding: 0 !important;
        border-radius: 0.5rem;
      }
    }

    // 小屏手机（≤500px）进一步压缩间距
    @media (max-width: 500px) {
      .cols-2,
      .cols-3 {
        margin: 0 4px;
        gap: 4px;

        .chat-content {
          border-radius: 0.25rem;
        }
      }

      // 小屏手机 3列变2列
      .cols-3 {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }

}

// PC端小屏幕适配 (768px - 1024px) - 优化布局
@media (max-width: 1024px) and (min-width: 768px) {
  .chat-container {
    max-width: none;
  }
}

// 无模型选择时的空状态
.empty-conversations {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;

  .empty-tip {
    color: #999999;
    font-size: 16px;
    text-align: center;
  }
}

// 拖拽遮罩层
.drag-overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  border: 2px dashed #EAEAEA;
  margin: 20px;
  pointer-events: none;

  .drag-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;

    .drag-text {
      color: #333333;
      font-size: 20px;
      font-weight: 500;
      margin: 0;
      text-align: center;
    }
  }
}

// 拖拽淡入淡出动画
.drag-fade-enter-active,
.drag-fade-leave-active {
  transition: opacity 0.3s ease;
}

.drag-fade-enter-from,
.drag-fade-leave-to {
  opacity: 0;
}
</style>
